module.exports = __webpack_public_path__ + "img/1485887405.0c810310.jpg";